import api from './index'
import request from '@/utils/request'

export function getRegoin(data) {
  return request({
    url: api.GetRegoin,
    method: 'post',
    data
  })
}

export function getIndustry(data) {
  return request({
    url: api.GetIndustry,
    method: 'post',
    data
  })
}

export function getTag(data) {
  return request({
    url: api.GetTag,
    method: 'post',
    data
  })
}

export function getToken(data) {
  return request({
    url: api.UploadToken,
    method: 'post',
    data
  })
}

export function addTag(data) {
  return request({
    url: api.AddTag,
    method: 'post',
    data,
    showloading: true
  })
}

export function deleteTag(data) {
  return request({
    url: api.DeleTag,
    method: 'post',
    data,
    showloading: true
  })
}

export function publishVRImg(data) {
  return request({
    url: api.AddVRImg,
    method: 'post',
    data,
    showloading: true
  })
}

export function getMaterial(data) {
  return request({
    url: api.GetMaterial,
    method: 'post',
    data
  })
}
export function regionTree(data) {
  return request({
    url: api.regionTree,
    method: 'post',
    data
  })
}

